import { ConditionalWrapper } from '@cian/conditional-component';
import { useIsDesktop } from '@cian/valuation-utils-component';
import { ArticleHeading1, ArticleHeading3, LinkButton } from '@cian/ui-kit';

import { Wrapper } from '../Wrapper';
import { applicationFormUrl } from '../../constants/urls';
import { NBSP } from '../../constants/symbols';

import * as styles from './styles.css';

export interface IContactsProps {
  onClickGoToApplicationForm(): void;
}

export const Contacts: React.FC<IContactsProps> = ({ onClickGoToApplicationForm }) => {
  const isDesktop = useIsDesktop();

  return (
    <div className={styles['container']}>
      <Wrapper>
        <div className={styles['card']}>
          <div className={styles['title']}>
            <ConditionalWrapper if={isDesktop} ThenComponent={ArticleHeading1} ElseComponent={ArticleHeading3}>
              <>
                Обратитесь к{NBSP}риелтору-партнёру Циан по{NBSP}любому вопросу с{NBSP}недвижимостью
              </>
            </ConditionalWrapper>
          </div>
          <LinkButton
            data-testid="Contacts_link"
            href={applicationFormUrl}
            onClick={onClickGoToApplicationForm}
            theme="fill_primary"
            size="L"
          >
            Подобрать риелтора
          </LinkButton>
        </div>
      </Wrapper>
    </div>
  );
};

Contacts.displayName = 'Contacts';
